import { render, staticRenderFns } from "./PageScrollerTwoButtons.vue?vue&type=template&id=b743a97c&scoped=true&lang=pug&"
import script from "./PageScrollerTwoButtons.vue?vue&type=script&lang=js&"
export * from "./PageScrollerTwoButtons.vue?vue&type=script&lang=js&"
import style0 from "./PageScrollerTwoButtons.vue?vue&type=style&index=0&id=b743a97c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b743a97c",
  null
  
)

export default component.exports